import { ImageGenerationApiFailReason } from 'js/types';

const IMAGE_GEN_ERROR_MESSAGE: Record<ImageGenerationApiFailReason, string> = {
  [ImageGenerationApiFailReason.PROMPT_REJECTED]:
    "Looks like your prompt didn't quite follow our content check. Please rework it and try again.",
  [ImageGenerationApiFailReason.SERVER_ERROR]:
    'There was an error with the server so we could not generate your image. Please try again.',
  [ImageGenerationApiFailReason.TIMEOUT]: 'The image generation request timed out. Please try again.'
};

export function mapImageGenerationFailedReasonToMessage(reason: ImageGenerationApiFailReason): string {
  return IMAGE_GEN_ERROR_MESSAGE[reason] || 'An unknown error occurred. Please try again.';
}
